import {
  PermissionActions,
  PermissionSubjects,
} from "@repo/app-types/entities/teammatePermissions";
import {
  ColorPicker,
  type ColorPickerProps,
} from "@repo/ui/ColorPicker/colorPicker";
import type { FC } from "react";
import { Can } from "../../../helpers/teammateAuthorizationContext.js";

interface CompanyColorPickerProps extends ColorPickerProps {}

export const CompanyColorPicker: FC<CompanyColorPickerProps> = ({
  color,
  onChange,
}) => {
  return (
    <Can
      I={PermissionActions.UPDATE}
      a={PermissionSubjects.COMPANY_SETTINGS}
      passThrough={true}
    >
      {(allowed) => (
        <ColorPicker color={color} onChange={onChange} isDisabled={!allowed} />
      )}
    </Can>
  );
};
